import { render, staticRenderFns } from "./GridAcomodaciones.vue?vue&type=template&id=351c2018&"
import script from "./GridAcomodaciones.vue?vue&type=script&lang=js&"
export * from "./GridAcomodaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports